export const HELP_ACCOUNTS = "docs/backstage/accounts";
export const HELP_BACKSTAGE = "docs/backstage/home";
export const HELP_DEVICES = "docs/backstage/devices";
export const HELP_MY_PARTNER = "docs/backstage/my-partner";
export const HELP_PHONE_NUMBERS = "docs/backstage/phone-numbers";
export const HELP_PARTNERS = "docs/backstage/partners";
export const HELP_PBXES = "docs/backstage/pbxes";

export const HELP_DASHBOARD = "docs/dashboard/dashboard";

export const HELP_LOGS_CALLS = "docs/logs/call-log";
export const HELP_LOGS_FLEX_DESKS = "docs/logs/flex-desk-log";
export const HELP_LOGS_QUEUES = "docs/logs/queue-log";
export const HELP_LOGS_QUEUE_STATS = "docs/logs/queue-stats";
export const HELP_LOGS_QUEUE_MEMBERS = "docs/logs/queue-log";
export const HELP_LOGS_WEBHOOKS = "docs/logs/webhook-log";

export const HELP_PHONEBOOKS = "docs/phonebooks/phonebooks";

export const HELP_LIBRARY = "docs/media/library";
export const HELP_MUSIC_ON_HOLDS = "docs/media/music-on-hold";

export const HELP_USERS = "docs/call-flow/users";
export const HELP_MOBILE_USERS = "docs/call-flow/mobile-users";
export const HELP_GROUPS = "docs/call-flow/groups";
export const HELP_TIMETABLES = "docs/call-flow/timetables";
export const HELP_HOLIDAY_SETS = "docs/call-flow/holiday-sets";
export const HELP_INBOUNDS = "docs/call-flow/inbound-routes";
export const HELP_IVRS = "docs/call-flow/ivrs";
export const HELP_QUEUES = "docs/call-flow/queues";
export const HELP_VOICEMAILS = "docs/call-flow/voicemails";
export const HELP_CUSTOM_DESTINATIONS = "docs/call-flow/custom-destinations";
export const HELP_OUTBOUND_RULES = "docs/call-flow/outbound-rules";
export const HELP_CONFERENCES = "docs/call-flow/conferences";
export const HELP_DAYNIGHT = "docs/call-flow/switches";
export const HELP_CALL_PARKING = "docs/call-flow/call-parkings";
export const HELP_INTERCOM = "docs/call-flow/intercoms";

export const HELP_LINE_KEY_TEMPLATE = "docs/settings/line-key-templates";
export const HELP_DISTINCTIVE_RINGTONE = "docs/settings/distinctive-ringtones";
export const HELP_BLOCKLISTS = "docs/settings/blocklists";
export const HELP_WEBHOOKS = "docs/settings/webhooks";

export const HELP_PROVISIONING = "docs/provisioning/provisioning";

export const HELP_PBX = "docs/my-pbx/my-pbx";
